export const weight = {
    boldest: 900,
    bolder: 700,
    bold: 600,
    semibold: 500,
    normal: 400,
} as const;

export const family = {
    publicoHeadline: '"Publico Headline", "Noto Sans", "Noto Sans Thai Looped", serif',
    publicoText: '"Publico Text", "Noto Sans", "Noto Sans Thai Looped", serif',
    gotham: '"Gotham A", "Gotham B", "Noto Sans", "Noto Sans Thai Looped", sans-serif',
} as const;
